import Image from "next/image";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import Credit from "@/components/molecules/credit";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";

type InspirationImageProps = {
  image: string;
  imageAlt: string;
  link: string;
  imageCredit?: {
    text: string;
    avatarImage: string;
    name: string;
  };
  variant: "default" | "category";
  category?: string;
  className?: string;
  locale: Locales;
};

const InspirationImage = ({
  image,
  imageAlt,
  imageCredit,
  variant = "default",
  category,
  link,
  className,
  locale,
}: InspirationImageProps) => {
  return (
    <figure
      className={cn(
        "group relative aspect-square h-full max-h-[280px] w-full overflow-hidden rounded-lg sm:max-h-[485px] md:max-h-[748px]",
        className
      )}
    >
      {image && <Image src={image} alt={imageAlt} fill className="group-hover:scale-[102%] transition-all duration-200 ease-in-out absolute object-cover" />}{" "}
      {link && (
        <Link href={link} className="absolute inset-0">
          <span className="sr-only">{__("See inspiration", locale)}</span>
        </Link>
      )}
      {variant === "default" && imageCredit ? (
        <Credit
          locale={locale}
          button={{
            text: imageCredit?.text,
          }}
          image={imageCredit?.avatarImage}
          name={imageCredit.name}
          state="default"
          className="absolute bottom-5 left-4"
        />
      ) : (
        category && (
          <figcaption className="relavive shadow-festi absolute right-4 bottom-5 left-4 h-10.5 rounded-md bg-white px-3.5 py-2">
            <Link href={link} className="absolute inset-0">
              <span className="sr-only">{category}</span>
            </Link>
            {category && (
              <p className="font-cabinet-grotesk flex items-center justify-between font-medium">
                {category}
                <ArrowUpRight className="transition-all duration-200 ease-in-out group-hover:rotate-45" size={24} />
              </p>
            )}
          </figcaption>
        )
      )}
    </figure>
  );
};

export default InspirationImage;
